import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dictionary as baseDict } from "@/lib/i18n";
import { portalDict } from "@/lib/i18n_portal";

const dictionary = {
  de: { ...baseDict.de, ...portalDict.de },
  en: { ...baseDict.en, ...portalDict.en },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("de");

  useEffect(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
    if (stored === "de" || stored === "en") {
      setLangState(stored);
      document.documentElement.lang = stored;
    }
  }, []);

  const setLang = useCallback((next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      localStorage.setItem("lang", next);
      document.documentElement.lang = next;
    }
  }, []);

  const t = useCallback((key) => dictionary[lang][key] ?? key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
